import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    FormControlLabel,
    TextField,
    Typography
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Checkbox, Modal } from "antd";
import { addIdentificationType, getAllWorkerIdentificationTypes } from "../../../api/apiCall";
import { useAuth } from "../../../auth/auth";
import { toast } from "react-toastify";
import { Controller, useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faX } from "@fortawesome/free-solid-svg-icons";

const IdentificationType = () => {
    const {state} = useAuth();
    const [isModalCompetencyOpen, setIsModalCompetencyOpen] = useState(false);
    const [identificationType, setIdentificationType] = useState<any>([]);

    const handleCancelCompetency = () => {
        setIsModalCompetencyOpen(false);
    };

    const { control, register, handleSubmit } = useForm({
        defaultValues: {
            name: "",
            code: "",
            description: "",
            isActive: false,
            isRequired: false,
            maxLength: 0,
            validationRegex: ""
        }
    });

    const onSubmit = async (data: any) => {
        const response = await addIdentificationType(state.user?.token, data);
        if(response) {
            toast.success('Identification Type added successfully');
        };
    };

    const getAllIdenification = async () => {
        const response = await getAllWorkerIdentificationTypes(state.user?.token);
        setIdentificationType(response.data);
    }

    useEffect(() => {
        getAllIdenification();
    }, []);

    const identificationTypeColumns: any = [
        {
            field: "name",
            headerName: "Name",
            flex: 1
        },
        {
            field: "code",
            headerName: "Code",
            headerAlign: 'center',
            align: 'center',
            flex: 1,
        },
        {
            field: "description",
            headerName: "Description",
            headerAlign: 'center',
            align: 'center',
            flex: 1,
        },
        {
            field: "maxLength",
            headerName: "Max Length",
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: "isActive",
            headerName: "Is Active",
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => (
                <div>
                  {params.row.isActive ? (
                    <FontAwesomeIcon icon={faCheck} size={"lg"} color={"green"} />
                  ) : (
                    <FontAwesomeIcon icon={faX} size={"lg"} color={"red"} />
                  )}
                </div>
            ),
        },
        {
            field: "isRequired",
            headerName: "Is Required",
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => (
                <div>
                  {params.row.isRequired ? (
                    <FontAwesomeIcon icon={faCheck} size={"lg"} color={"green"} />
                  ) : (
                    <FontAwesomeIcon icon={faX} size={"lg"} color={"red"} />
                  )}
                </div>
            ),
        },
    ];

    return (
        <Box 
            sx={{
                margin: "auto",
                padding: 4,
                background: "#fff",
            }}>
            <Box display="flex" justifyContent="flex-end" mb={2}>
                <Button
                    variant="contained"
                    color="primary"
                    style={{boxShadow: "none", height: 40}}
                    onClick={() => setIsModalCompetencyOpen(true)}>
                        Add Identification Type
                </Button>
            </Box>
            <Box sx={{ height: "700px", width: "65%", margin: "0 auto" }}>
                <DataGrid
                    rows={identificationType}
                    columns={identificationTypeColumns}
                    sx={{
                        "& .MuiDataGrid-columnHeaderTitle": {
                            color: "#333",
                            fontWeight: "bold",
                            fontSize: 15.5,
                        }
                    }}
                />
            </Box>
            <Modal
                title={`Add identification type`}
                onCancel={handleCancelCompetency}
                open={isModalCompetencyOpen}
                footer={[
                    <div className="center-button-div">
                        <Button variant="contained" sx={{boxShadow: 'none', mb: 2}} onClick={handleSubmit(onSubmit)}>
                            Add identification type
                        </Button>
                    </div>
                ]}>
                <Box display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr" }} gap={4} p={1} mt={3}>
                    <TextField
                      label="Name"
                      fullWidth
                      size="small"
                      {...register("name")}
                    />
                    <TextField
                      label="Code"
                      {...register("code")}
                      fullWidth
                      size="small"
                    />
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Is Active"
                      sx={{ ml: 1 }}
                      {...register("isActive")}
                    />
                    
                    
                    <Typography fontSize={17}>
                        Driver: 
                        <Controller
                            name="isActive"
                            control={control}
                            render={({ field }) => <Checkbox {...field} checked={field.value} />}
                        />
                    </Typography><Typography fontSize={17}>
                        Driver: 
                        <Controller
                            name="isActive"
                            control={control}
                            render={({ field }) => <Checkbox {...field} checked={field.value} />}
                        />
                    </Typography>
                    <TextField
                      label="Max Length"
                      type="number"
                      fullWidth
                      size="small"
                      {...register("maxLength", { valueAsNumber: true })}
                    />
                    <TextField
                      label="Validation Regex"
                      fullWidth
                      size="small"
                      {...register("validationRegex")}
                    />
                    <TextField
                      label="Description"
                      {...register("description")}
                      multiline
                      size="small"
                      rows={4}
                      fullWidth
                    />
                </Box>
            </Modal>
        </Box>
    )
}

export default IdentificationType;
